import React from 'react';
import './Pagination.css';

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage = 10,
  onChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, '...', totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }
    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="pagination" role="navigation" aria-label="Pagination">
      {getPageNumbers().map((p, i) =>
        p === '...' ? (
          <span key={`e-${i}`} className="ellipsis">…</span>
        ) : (
          <button
            key={p}
            className={`page-button ${currentPage === p ? 'active' : ''}`}
            onClick={() => onChange?.(p)}
            aria-current={currentPage === p ? 'page' : undefined}
          >
            {p}
          </button>
        )
      )}
      <span className="results-text">{totalItems} | Results</span>
    </div>
  );
};

export default Pagination;
